import { createTheme } from '@mui/material/styles';

const darkTheme = createTheme({
  typography: {
    fontFamily: 'var(--font-inter), Inter, system-ui, -apple-system, sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
  },
  palette: {
    mode: 'dark',
    background: { default: '#0b1120', paper: '#111827' },
    primary: { main: '#3b82f6' },
    secondary: { main: '#ec4899' },
    text: {
      primary: '#f1f5f9',
      secondary: '#94a3b8',
    },
    divider: '#1e293b',
  },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8, textTransform: 'none' },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
});

export default darkTheme;